import { render, staticRenderFns } from "./BSMap.vue?vue&type=template&id=34e304cc&"
import script from "./BSMap.vue?vue&type=script&lang=js&"
export * from "./BSMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports